import { useApp } from "../context/AppContext";

const INTERIOR = "https://customer-assets.emergentagent.com/job_7f06c548-253d-46ff-97f6-8e1ce04a5d90/artifacts/c0yyfh0i_2158037C-C47C-4007-AC3E-FB88F9D340F9.png";

export default function About() {
    const { lang } = useApp();
    return (
        <div data-testid="about-page" className="pt-32 pb-24 max-w-[1400px] mx-auto px-6 lg:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                <div>
                    <div className="overline mb-4">{lang === "ar" ? "من نحن" : "About Us"}</div>
                    <h1 className="section-heading text-4xl md:text-6xl text-white mb-8 leading-[1.05]">
                        {lang === "ar" ? "فخامة الصحراء بتوقيعٍ إماراتي" : "Desert Luxury, Signed by the UAE"}
                    </h1>
                    <div className="hairline w-24 mb-8" />
                    <p className="text-white/75 text-lg leading-relaxed mb-6">
                        {lang === "ar"
                            ? "سراء تنت متخصصة في تصميم وتصنيع الخيام الفاخرة والمجالس العربية الحديثة. نجمع بين حرفية الصناعة الإماراتية الأصيلة وأحدث معايير الراحة والذوق الرفيع."
                            : "SRAA TENT specializes in designing and crafting luxury tents and modern Arabian majlis. We combine authentic Emirati craftsmanship with the finest standards of comfort and taste."}
                    </p>
                    <p className="text-white/70 leading-relaxed">
                        {lang === "ar"
                            ? "من قلب أبوظبي، نخدم عملاءنا في جميع أنحاء الإمارات بمنتجات مصنوعة يدويًا وبأعلى جودة، لنقدم لكم تجربة إقامة وضيافة لا تُنسى."
                            : "From the heart of Abu Dhabi, we serve clients across the UAE with handmade, premium quality products — delivering an unforgettable hospitality experience."}
                    </p>
                </div>
                <div className="relative aspect-[4/5]">
                    <div className="absolute inset-0 border border-[#D4AF37]/30 translate-x-4 translate-y-4" />
                    <img src={INTERIOR} alt="Majlis" className="relative w-full h-full object-cover border border-[#D4AF37]/40" />
                </div>
            </div>
        </div>
    );
}
